import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { CheckCircleIcon, PlayCircleIcon } from '@heroicons/react/24/solid';

interface StartEndNodeData {
  label: string;
  status: 'completed' | 'pending' | 'default';
}

export const StartEndNode = memo(({ data }: { data: StartEndNodeData }) => {
  const { label, status } = data;

  const getNodeStyle = () => {
    if (status === 'completed') {
      return 'bg-green-500 text-white border-green-600';
    } else if (status === 'pending') {
      return 'bg-gray-300 text-gray-600 border-gray-400';
    }
    return 'bg-blue-500 text-white border-blue-600';
  };

  const getIcon = () => {
    if (label === 'START') {
      return <PlayCircleIcon className="h-8 w-8" />;
    } else if (label === 'COMPLETE') {
      return <CheckCircleIcon className="h-8 w-8" />;
    }
    return null;
  };

  const isStart = label === 'START';
  const isEnd = label === 'COMPLETE';

  return (
    <>
      {!isStart && <Handle type="target" position={Position.Top} />}
      <div
        className={`
          px-6 py-4 rounded-full shadow-lg border-2 font-bold
          flex flex-col items-center justify-center
          ${getNodeStyle()}
          min-w-[140px]
        `}
      >
        {getIcon()}
        <span className="text-sm mt-1">{label}</span>
        {status === 'pending' && isEnd && (
          <span className="text-xs mt-1 opacity-75">Est: Mar 30</span>
        )}
      </div>
      {!isEnd && <Handle type="source" position={Position.Bottom} />}
    </>
  );
});